export default __webpack_public_path__ + "static/media/profile-icon.189f66a6.png";